import React, { useMemo } from 'react'
import { t } from 'i18next'
import PropTypes from 'prop-types'
import warranty from 'Assets/Images/Product/warranty.svg'
import { noWarranty } from 'Utils/constants'
import { Formatter } from 'Utils/Formatter'
import './ExtendedWarrantyCard.css'

const ExtendedWarrantyCard = ({
  title = t('EXTENDED_WARRANTY_T.EXTENDED_WARRANTY_LABEL'),
  showDescription = true,
  price,
  product,
  groupName,
  warrantyOptions,
  selectedWarranty,
  onWarrantySelectChange,
  styleCard = {},
}) => {
  const enrichedWarrantyOptions = useMemo(() => {
    return warrantyOptions.map(option => ({
      ...option,
      WarrantyProductId: product?.ProductId,
      CalculatedPrice: (price * option.WarrantyPercent) / 100,
    }))
  }, [warrantyOptions, price, product?.ProductId])

  if (!warrantyOptions || warrantyOptions.length === 0) return null

  const handleSelect = option => {
    if (onWarrantySelectChange) {
      onWarrantySelectChange(option)
    }
  }

  return (
    <div className="product-warranty" style={styleCard}>
      <div className="product-warranty-header">
        <img src={warranty} alt="warranty" />
        <h2>{title}</h2>
      </div>

      {showDescription && (
        <div className="product-warranty-text">
          <p>{t('EXTENDED_WARRANTY_T.EXTENDED_WARRANTY_DESCRIPTION')}</p>
        </div>
      )}

      <ul className="product-warranty-options">
        {enrichedWarrantyOptions.map(option => (
          <li key={option.ExtendedWarrantyId}>
            <input
              type="radio"
              name={groupName}
              className="warranty-option"
              id={`${groupName}-${option.ExtendedWarrantyId}`}
              checked={selectedWarranty?.WarrantyYears === option.WarrantyYears}
              onChange={() => handleSelect(option)}
            />
            <label htmlFor={`${groupName}-${option.ExtendedWarrantyId}`}>
              {option.WarrantyYears} {t('YEAR')}
              {option.WarrantyYears > 1 ? 's' : ''} $
              {Formatter.Money(option.CalculatedPrice)}
            </label>
          </li>
        ))}
        <li>
          <input
            type="radio"
            name={groupName}
            className="warranty-option"
            id={`${groupName}-no-warranty`}
            checked={
              selectedWarranty?.WarrantyYears === noWarranty.WarrantyYears
            }
            onChange={() => handleSelect(noWarranty)}
          />
          <label htmlFor={`${groupName}-no-warranty`}>
            {t('EXTENDED_WARRANTY_T.NO_EXTENDED_WARRANTY')}
          </label>
        </li>
      </ul>
    </div>
  )
}

ExtendedWarrantyCard.propTypes = {
  title: PropTypes.string,
  showDescription: PropTypes.bool,
  price: PropTypes.number,
  product: PropTypes.shape({
    ProductId: PropTypes.string,
    LineNum: PropTypes.number,
  }),
  groupName: PropTypes.string.isRequired,
  warrantyOptions: PropTypes.arrayOf(
    PropTypes.shape({
      ExtendedWarrantyId: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired,
      WarrantyYears: PropTypes.number.isRequired,
      WarrantyPercent: PropTypes.number.isRequired,
    })
  ).isRequired,
  selectedWarranty: PropTypes.shape({
    Name: PropTypes.string,
    Code: PropTypes.string,
    WarrantyYears: PropTypes.number,
  }),
  onWarrantySelectChange: PropTypes.func,
  styleCard: PropTypes.object,
}

export default React.memo(ExtendedWarrantyCard)
